/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_Slug_ColInputs */

const en_admin_categories_slug_col = /** @type {(inputs: Admin_Categories_Slug_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

const zh_admin_categories_slug_col = /** @type {(inputs: Admin_Categories_Slug_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标识`)
};

/**
* | output |
* | --- |
* | "Slug" |
*
* @param {Admin_Categories_Slug_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_slug_col = /** @type {((inputs?: Admin_Categories_Slug_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_Slug_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_slug_col(inputs)
	return zh_admin_categories_slug_col(inputs)
});
export { admin_categories_slug_col as "admin.categories.slug_col" }